export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden',
        padding: '16px',
        rowGap: 2,
    },
    heading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        width: '100%',
        '& .MuiSvgIcon-root': {
            position: 'absolute',
            left: 0,
        },
        '& > div': {
            paddingLeft: '32px',
            paddingRight: '32px',
        },
    },
    iconCompleted: {
        color: 'rgb(145, 85, 253)',
    },
};
